export default "__VITE_ASSET__vDrzPUOS__"